import { render, staticRenderFns } from "./MapButton.vue?vue&type=template&id=20ad10bc&scoped=true&"
import script from "./MapButton.vue?vue&type=script&lang=js&"
export * from "./MapButton.vue?vue&type=script&lang=js&"
import style0 from "./MapButton.vue?vue&type=style&index=0&id=20ad10bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad10bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ad10bc')) {
      api.createRecord('20ad10bc', component.options)
    } else {
      api.reload('20ad10bc', component.options)
    }
    module.hot.accept("./MapButton.vue?vue&type=template&id=20ad10bc&scoped=true&", function () {
      api.rerender('20ad10bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/CommonFilters/MapButton.vue"
export default component.exports